import { render, staticRenderFns } from "./RobTable.vue?vue&type=template&id=35a50e1b"
import script from "./RobTable.vue?vue&type=script&lang=js"
export * from "./RobTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports